import { toRFC3339UTC } from './geohashUtil';

/**
 * Thread votes (community_thread_votes_beta).
 * value: 1 = up, -1 = down. up_count / down_count on threads are derived from this.
 */
export const SEED_VOTES = [
  { thread_id: 1, user_id: 1002, value: 1, created_at: toRFC3339UTC(new Date()) },
  { thread_id: 1, user_id: 1003, value: 1, created_at: toRFC3339UTC(new Date()) },
  { thread_id: 1, user_id: 1004, value: 1, created_at: toRFC3339UTC(new Date()) },
  { thread_id: 2, user_id: 1001, value: 1, created_at: toRFC3339UTC(new Date()) },
  { thread_id: 2, user_id: 1004, value: 1, created_at: toRFC3339UTC(new Date()) },
  { thread_id: 2, user_id: 1005, value: 1, created_at: toRFC3339UTC(new Date()) },
  { thread_id: 2, user_id: 1006, value: 1, created_at: toRFC3339UTC(new Date()) },
  { thread_id: 5, user_id: 1001, value: 1, created_at: toRFC3339UTC(new Date()) },
  { thread_id: 5, user_id: 1002, value: 1, created_at: toRFC3339UTC(new Date()) },
  { thread_id: 5, user_id: 1006, value: -1, created_at: toRFC3339UTC(new Date()) },
  { thread_id: 8, user_id: 1003, value: -1, created_at: toRFC3339UTC(new Date()) },
  // Thread 3: heavily downvoted — excluded from trending feed (down_count >= 10)
  { thread_id: 3, user_id: 1001, value: -1, created_at: toRFC3339UTC(new Date()) },
  { thread_id: 3, user_id: 1002, value: -1, created_at: toRFC3339UTC(new Date()) },
  { thread_id: 3, user_id: 1004, value: -1, created_at: toRFC3339UTC(new Date()) },
  { thread_id: 3, user_id: 1005, value: -1, created_at: toRFC3339UTC(new Date()) },
  { thread_id: 3, user_id: 1006, value: -1, created_at: toRFC3339UTC(new Date()) },
  { thread_id: 3, user_id: 1007, value: -1, created_at: toRFC3339UTC(new Date()) },
  { thread_id: 3, user_id: 1008, value: -1, created_at: toRFC3339UTC(new Date()) },
  { thread_id: 3, user_id: 1009, value: -1, created_at: toRFC3339UTC(new Date()) },
  { thread_id: 3, user_id: 1010, value: -1, created_at: toRFC3339UTC(new Date()) },
  { thread_id: 3, user_id: 1011, value: -1, created_at: toRFC3339UTC(new Date()) },
  { thread_id: 3, user_id: 1012, value: -1, created_at: toRFC3339UTC(new Date()) },
  { thread_id: 7, user_id: 1001, value: 1, created_at: toRFC3339UTC(new Date()) },
  { thread_id: 9, user_id: 1002, value: 1, created_at: toRFC3339UTC(new Date()) },
  { thread_id: 11, user_id: 1003, value: 1, created_at: toRFC3339UTC(new Date()) },
  { thread_id: 12, user_id: 1001, value: 1, created_at: toRFC3339UTC(new Date()) },
  { thread_id: 12, user_id: 1002, value: 1, created_at: toRFC3339UTC(new Date()) },
  { thread_id: 13, user_id: 1010, value: 1, created_at: toRFC3339UTC(new Date()) },
  { thread_id: 18, user_id: 1015, value: 1, created_at: toRFC3339UTC(new Date()) },
  { thread_id: 19, user_id: 1016, value: 1, created_at: toRFC3339UTC(new Date()) },
  { thread_id: 28, user_id: 1025, value: 1, created_at: toRFC3339UTC(new Date()) },
];
